// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assignment-date .sk-time-picker__description {\n  height: 22px;\n}\n@media (max-width: 767px) {\n.assignment-date .sk-time-picker__description {\n    height: 20px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
